import { useTranslation } from '@klv/hooks/useTranslation';

import Button from '@klv/atoms/button';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/not-found.module.scss';

import type { INotFound } from './types';

const NotFound = ({
  bodyCopy,
  button,
  ...props
}: INotFound) => {
  const { t } = useTranslation();
  const HEADLINE = `${t('pages_notFound_itsPronounced')}<br/><strong>Clay-vee–oh. </strong><br/><em>Clay</em>-vee-oh.<br/><span aria-label="Clay-vee-oh">Claaay-vee-oh.</span>`;
  const BODY_COPY = bodyCopy === undefined ? t('pages_notFound_bodyCopy') : bodyCopy;
  const BUTTON = {
    openInNewTab: button?.openInNewTab || false,
    text: button?.text || t('pages_notFound_button') || '',
    to: button?.url || (t('langCodes_pathPrefix') ? `/${t('langCodes_pathPrefix')}/` : '/'),
  };

  return (
    <div className={styles.notFound} {...props}>
      <div className={generateClassName(['grid', styles.container])}>
        <div className={generateClassName(['eyebrow', styles.eyebrow])}>{t('pages_notFound_eyebrow') || 'Page not found'}</div>
        <h1 
          className={generateClassName(['display1', styles.headline])} 
          dangerouslySetInnerHTML={{ __html: HEADLINE }}
        />
        {BODY_COPY && (
          <p className={generateClassName(['p2', styles.content])}
            dangerouslySetInnerHTML={{ __html: BODY_COPY }}
          />
        )}
        <div className={styles.row}>
          <Button {...BUTTON} variant="primary" />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
